export default __webpack_public_path__ + "d4978ed6e00aa02286fab99f06fac85d.png";